import './home.css';

import React from 'react';

const Home = () => <>HOME</>;

export default Home;
